<template>
  <div>
    <settings-card
      v-loading="loading"
      :config="config">
      <el-button
        type="text"
        @click="payApply">去设置</el-button>
    </settings-card>
    <wx-pay-apply-modal
      ref="pay"
      :applyInfo="userDetail" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SettingsCard from './settings-card.vue'
import WxPayApplyModal from '@/components/layout/busi/wx-pay-apply-modal.vue'
export default {
  name: 'PayCard',
  components: {
    SettingsCard,
    WxPayApplyModal
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.wxaccount.userDetail
    })
  },
  methods: {
    payApply() {
      this.$refs.pay.toggleModal(true)
    }
  }
}
</script>
